<template>
  <v-container fluid>
    <v-card>
      <v-card-title>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Suche"
          single-line
          hide-details
        />
      </v-card-title>
      <v-data-table
        :headers="itemHeaders"
        :items="stocks"
        :search="search"
        :single-expand="true"
        :expanded.sync="expanded"
        item-key="name"
        show-expand
        hide-default-footer
        disable-pagination
      >
        <template #expanded-item="{ headers, item }">
          <td
            :colspan="headers.length"
          >
            <v-simple-table class="ma-3">
              <template #default>
                <thead>
                  <tr>
                    <th class="text-left">
                      Name
                    </th>
                    <th class="text-left">
                      Menge
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(warehouse,name) in item.warehouses"
                    :key="name"
                  >
                    <td>{{ name }}</td>
                    <td>{{ warehouse.amount }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </td>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import Layout from '@/Layouts/Admin'
export default {

   metaInfo () {
      // don't know your return object structure,
      // maybe you should check whole this.getViewPage
      return {
         title: this.title ? this.title : 'Lager Einkaufsartikel',
      }
   },
   layout: (h, page) => h(Layout, [page]),
   props: {
      stocks: {
         type: Object,
         required: true,
      }

   },
   data () {
      return {
         search: '',
         expanded: [],
         itemHeaders: [
            { text: 'Name', value: 'name' },
            { text: 'Menge', value: 'amount' },
            { text: '', value: 'data-table-expand' },
         ]
      }
   }
}
</script>

<style lang="sass" scoped>
.v-card.on-hover.theme--dark
  background-color: rgba(#FFF, 0.8)
  >.v-card__text
    color: #000
</style>
